import { createApp } from 'vue'
import DepremKarsilastirma from './DepremKarsilastirma.vue'
import './assets/global.css'

createApp(DepremKarsilastirma).mount('#deprem-karsilastirma')
